import { WeighmentSitesAPI } from "api";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useSettingContext } from "context/SettingContext";
const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  const settingsData = useSettingContext();
  const methods_status = useMemo(
    () =>
      settingsData?.filter(
        (d) =>
          d.name === "ECOM_PAYMENT_METHODS" ||
          d.name === "ECOM_PAYMENT_STATUSES"
      ),
    [settingsData]
  );

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Order Number"
                  title="Order Number"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.orderNumber}
                  {...register("orderNumber")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.orderNumber?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Amount"
                  title="Amount"
                  className="py-2 "
                  isInvalid={!!errors.amount}
                  {...register("amount")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.amount?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="paymentMethod"
                  type="text"
                  title="Payment Method"
                  className="py-2 mb-1"
                  isInvalid={!!errors?.paymentMethod}
                  {...register("paymentMethod")}
                >
                  <option value="">Select Payment Method</option>
                  {methods_status
                    ?.find((item) => item.name === "ECOM_PAYMENT_METHODS")
                    ?.value?.split(",")
                    .map((method, index) => (
                      <option key={index} value={method.trim()}>
                        {method.trim()}
                      </option>
                    ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.paymentMethod?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="paymentStatus"
                  type="text"
                  title="Payment Status"
                  className="py-2 mb-1"
                  isInvalid={!!errors?.paymentStatus}
                  {...register("paymentStatus")}
                >
                  <option value="">Select Payment Status</option>
                  {methods_status
                    ?.find((item) => item.name === "ECOM_PAYMENT_STATUSES")
                    ?.value?.split(",")
                    .map((status, index) => (
                      <option key={index} value={status.trim()}>
                        {status.trim()}
                      </option>
                    ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.paymentStatus?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Transaction Reference"
                  title="Transaction Reference"
                  className="py-2 "
                  isInvalid={!!errors.transactionReference}
                  {...register("transactionReference")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.transactionReference?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Payment Made On"
                  title="Payment Made On"
                  className="py-2 "
                  isInvalid={!!errors.paymentMadeOn}
                  {...register("paymentMadeOn")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.paymentMadeOn?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
